import React from 'react';
import * as S from './styles';

const InputRadio = React.forwardRef(
  ({ name, label, value, error, required = false, onChange, checked, ...rest }, ref) => {
    return (
      <S.RadioWrapper>
        <S.RadioLabel>
          <S.Radio
            ref={ref}
            id={`${name}-${value}`}
            name={name}
            type="radio"
            value={value}
            required={required}
            onChange={onChange}
            checked={checked}
            {...rest}
          />
          <span>{label}</span>
        </S.RadioLabel>
        {error && <S.Error>{error}</S.Error>}
      </S.RadioWrapper>
    );
  },
);

InputRadio.displayName = 'InputRadio';

export default InputRadio;
